<template>
    <v-layout row wrap class="notifications_container">
        <v-flex md12>
            <div class="notifications-title__wrapper">
                <v-layout align-center row wrap
                          justify-space-between
                          class="notifications__title-block"
                >
                    <v-flex>
                        <h1 class="note_tite">{{ $t("Настройка уведомлений") }}</h1>
                    </v-flex>
                </v-layout>
                <v-layout row wrap justify-start
                          align-center
                          class="notifications__subtitle-cont"
                >
                    <v-flex md4 xs12
                            class="switcher notifications_switcher"
                    >
                        <v-switch
                            v-model="push_events"
                            :label="$t('Push-уведомления')"
                            :checked="push_events"
                        />
                    </v-flex>
                    <v-flex md4 xs12
                            class="switcher"
                    >
                        <v-switch
                            v-model="email_events"
                            :label="$t('Email-оповещения')"
                            :checked="email_events"
                        />
                    </v-flex>
                </v-layout>
            </div>
            <v-layout column justify-start class="notifications__table">
                <v-layout row>
                    <v-flex md6 ld6 xs6
                            class="notifications__col"
                    >
                        <div class="notifications__item notifications__title">
                            {{ $t("типы уведомлений") }}
                        </div>
                        <div v-for="(item, i) in settings" :key="i" class="notifications__item block">
                            {{ item.name }}
                        </div>
                    </v-flex>
                    <v-flex md3 ld3 xs3
                            class="notifications__col"
                    >
                        <div class="notifications__item title notifications__title">
                            <span class="text">{{ $t("Push-уведомления") }}</span>
                            <span class="text mobile">Push</span>
                        </div>
                        <div v-for="(item, i) in settings" :key="i" class="notifications__item block">
                            <checkbox :checked = settings[i].push
                                      @input="check_push($event, i)"
                            />
                        </div>
                    </v-flex>
                    <v-flex md3 ld3 xs3
                            class="notifications__col"
                    >
                        <div class="notifications__title title notifications__item">
                            <span class="text">{{ $t("Email-уведомления") }}</span>
                            <span class="text mobile">Email</span>
                        </div>
                        <div v-for="(item, i) in settings" :key="i" class="notifications__item block">
                            <checkbox :checked="settings[i].email"
                                      :disabled="['ucp', 'ua'].includes(i)"
                                      @input="check_mail($event, i)"
                            />
                        </div>
                    </v-flex>
                </v-layout>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
import {mapGetters, mapMutations, mapActions} from 'vuex';
import {base_input, base_checkbox} from '@/components/ui/inputs/base/base_inputs.js';
export default {
  components: {
    'checkbox': base_checkbox,
  },
  data() {
    return {
      new_settings: [],
      ua: false,
      ucp: false,
    };
  },
  computed: {
    ...mapGetters('notifications/edit', [
      'settings',
      'email_events_value',
      'push_events_value',
    ]),
    push_events: {
      get() {
        return this.push_events_value;
      },
      set(value) {
        this.new_settings = [];
        let push_settings = Object.keys(this.settings);
        push_settings.forEach((key)=>{
          let obj = {
            'code' : key,
            'push' : value,
            'email': this.settings[key].email || false,
          };
          this.new_settings.push(obj);
        });
        this.notifications_edit(this.new_settings);
        return this.SET_PUSH_EVENTS(value);
      },
    },
    email_events: {
      get() {
        return this.email_events_value;
      },
      set(value) {
        this.new_settings = [];
        let push_settings = Object.keys(this.settings);
        push_settings.forEach((key)=>{
          let obj = {
            'code' : key,
            'push' : this.settings[key].push || false,
            'email': value,
          };
          this.new_settings.push(obj);
        });
        this.notifications_edit(this.new_settings);
        return this.SET_EMAIL_EVENTS(value);
      },
    },
  },
  async mounted() {
    await this.get_notifications_settings();
  },
  beforeMount() {
    this.auto();
  },
  methods: {
    ...mapMutations('notifications/edit', [
      'UPDATE_NOTIFICATIONS_SETTINGS',
      'SET_STATE_NOTIFICATIONS',
      'SET_CHECKBOX_PUSH',
      'SET_CHECKBOX_MAIL',
      'SET_PUSH_EVENTS',
      'SET_EMAIL_EVENTS',
    ]),
    ...mapMutations('common', [
      'LOADING_ON',
      'LOADING_OFF',
    ]),
    ...mapActions('notifications/edit', ['get_notifications_settings', 'notifications_edit']),
    simulate_loading() {
      this.LOADING_ON();

      setTimeout(this.LOADING_OFF, (Math.random() * 500 + 500).toFixed(0));
    },
    check_push(e, index) {
      const obj = {'code': index, 'email': this.settings[index].email || false, 'push': e.target.checked};
      if (index === 'ua') {
        console.log(e.target.checked);
        this.ua = e.target.checked;
      } else if (index === 'ucp') {
        this.ucp = e.target.checked;
      }
      this.new_settings.push(obj);
      this.notifications_edit(this.new_settings);

      this.UPDATE_NOTIFICATIONS_SETTINGS({key: 'push', value: e.target.checked, name: index});
    },
    check_mail(e, index) {
      const obj = {'code': index, 'email': e.target.checked, 'push': this.settings[index].push || false};
      this.new_settings.push(obj);
      this.notifications_edit(this.new_settings);

      this.UPDATE_NOTIFICATIONS_SETTINGS({key: 'email', value: e.target.checked, name: index});
    },
    auto() {
      const obj = {'code': 'ua', 'email': true, 'push': this.settings['ua'].push || false};
      this.new_settings.push(obj);
      const obj2 = {'code': 'ucp', 'email': true, 'push': this.settings['ucp'].push || false};
      this.new_settings.push(obj2);
      this.notifications_edit(this.new_settings);

      this.UPDATE_NOTIFICATIONS_SETTINGS({key: 'email', value: true, name: 'ua'}, {key: 'email', value: true, name: 'ucp'});
    },
  },
};
</script>


